import React from 'react';
import styles from './styles.module.scss';

import LinkWrap from '../../Wraps/LinkWrap';

import Config, { spanish } from '../../../config/config';

const Layout = ({ data, children }) => {
  const {
    TitleSpanish,
    TitleEnglish,
    TopBannerMobile,
    TopBannerDesktop,
    BigBottomLink,
    BigBottomExternal,
    BigBottomMobile,
    BigBottomDesktop,
    SmallBottomLink,
    SmallBottomExternal,
    SmallBottomMobile,
    SmallBottomDesktop,
  } = data;
  return (
    <div className={styles.container}>
      <picture className={styles.topBanner}>
        <source
          srcSet={Config.cdn.cdn_path + TopBannerDesktop.url}
          media="(min-width: 1025px)"
        />
        <img
          src={Config.cdn.cdn_path + TopBannerMobile.url}
          alt={spanish ? TitleSpanish : TitleEnglish}
        />
      </picture>
      <h2 className={styles.title}>{spanish ? TitleSpanish : TitleEnglish}</h2>
      {children}
      <div className={styles.bottomBanners}>
        <LinkWrap
          to={BigBottomLink}
          isExternal={BigBottomExternal}
          className={styles.bigBanner}
        >
          <picture>
            <source
              srcSet={Config.cdn.cdn_path + BigBottomDesktop.url}
              media="(min-width: 1025px)"
            />
            <img
              src={Config.cdn.cdn_path + BigBottomMobile.url}
              alt={spanish ? TitleSpanish : TitleEnglish}
            />
          </picture>
        </LinkWrap>
        <LinkWrap
          to={SmallBottomLink}
          isExternal={SmallBottomExternal}
          className={styles.smallBanner}
        >
          <picture>
            <source
              srcSet={Config.cdn.cdn_path + SmallBottomDesktop.url}
              media="(min-width: 1025px)"
            />
            <img
              src={Config.cdn.cdn_path + SmallBottomMobile.url}
              alt={spanish ? TitleSpanish : TitleEnglish}
            />
          </picture>
        </LinkWrap>
      </div>
    </div>
  );
};

export default Layout;
